module.exports = __webpack_public_path__ + "static/media/615.81bc7fad.png";